import { create } from "zustand";

type UserStoreType = {
    setStoreUserId: (userId: string) => void;
    userId?: string;
};

export const useUserSimplifiedStore = create<UserStoreType>((set) => ({
    setStoreUserId: (userId) => {
        set({ userId });
    },
}));
